/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { NUMBER_UNIT } from '@hems/util/src/constant/constant';
export const ONE_MILE_TO_KILOMETER = 1.609;
export const WATT_HOUR_UNIT = {
    WATT_HOUR: 'Wh',
    KILO_WATT_HOUR: 'kWh',
    MEGA_WATT_HOUR: 'MWh',
};
export const WATT_PEAK_UNIT = {
    WATT_PEAK: 'Wp',
    KILO_WATT_PEAK: 'kWp',
    MEGA_WATT_PEAK: 'MWp',
};
export const NUMBER_UNIT_WATT_HOUR_UNIT_MAP = {
    [NUMBER_UNIT.MILLION]: WATT_HOUR_UNIT.MEGA_WATT_HOUR,
    [NUMBER_UNIT.TEN_THOUSAND]: WATT_HOUR_UNIT.KILO_WATT_HOUR,
    [NUMBER_UNIT.THOUSAND]: WATT_HOUR_UNIT.KILO_WATT_HOUR,
    [NUMBER_UNIT.HUNDRED]: WATT_HOUR_UNIT.WATT_HOUR,
};
export const NUMBER_UNIT_WATT_PEAK_UNIT_MAP = {
    [NUMBER_UNIT.MILLION]: WATT_PEAK_UNIT.MEGA_WATT_PEAK,
    [NUMBER_UNIT.TEN_THOUSAND]: WATT_PEAK_UNIT.KILO_WATT_PEAK,
    [NUMBER_UNIT.THOUSAND]: WATT_PEAK_UNIT.KILO_WATT_PEAK,
    [NUMBER_UNIT.HUNDRED]: WATT_PEAK_UNIT.WATT_PEAK,
};
export const CAPACITY_UINT_TYPE = {
    HOUR: 'hour',
    PEAK: 'peak',
};
export const UNIT = {
    WATT: 'W',
    WATT_HOUR: 'Wh',
    WATT_PEAK: 'Wp',
    VOLT: 'V',
    PERCENT: '%',
    CELSIUS: '°C',
    AMPERE: 'A',
    HERTZ: 'Hz',
    /** 유효 전력 단위 */
    VOLT_AMPERE: 'VA',
    /** 무효 전력 단위 */
    VOLT_AMPERE_REACTIVE: 'VAR',
    FACTOR: 'factor',
    DEGREE: '°',
    FAHRENHEIT: '°F',
};
export const INTL_NUMBER_FORMAT_UNIT = {
    FAHRENHEIT: 'fahrenheit',
    CELSIUS: 'celsius',
    PERCENT: 'percent',
    MILE_PER_HOUR: 'mile-per-hour',
    KILOMETER_PER_HOUR: 'kilometer-per-hour',
};
export const METRIC_PREFIX = {
    MEGA: 'M',
    KILO: 'k',
};
export const DECIMAL_PLACES = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
};
